import { Button, CountrySelect, Header, Icon, LoadingSpinner } from '@/components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@store/Root.store'

import { onKeyDownHandler } from '@/methods/keyboardAccessibility'
import { useDocumentType } from '@/hooks/useDocumentType'
import { actionReport } from '@/methods/actionReport'
import { cx } from '@/utils/cx'

export const DocumentTypeEnpalPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState

  const { themeId } = store.InterfaceState
  const { currentScenarioId, context } = store.ScenarioState
  const { documentTypePage: trans } = store.TranslationsState.translations

  const {
    docType,
    changeSelectedDocumentType,
    country,
    apiCountries,
    countryDocTypes,
    btnLoading,
    getDocLabel,
    getDocIcon,
    setSelectedCountry,
    handleProceed,
  } = useDocumentType(currentScenarioId, context && context.shouldSelectDocument, 'DE', trans)

  useEffect(() => {
    if (context && context.shouldSelectDocument) {
      actionReport({
        type: 'event.onboarding-web.document-selection.PAGE_OPENED',
        payload: {},
      })
    }
  }, [context])

  if (!context || (context && !context.shouldSelectDocument)) {
    return (
      <div className="page-container">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className="page-container">
      <Header>{trans.header}</Header>
      <div className="generic__country-wrap">
        <span>{trans.selectCountry}</span>
        {isMobile ? (
          <CountrySelect
            externalList={apiCountries}
            value={country}
            onChange={(value) => setSelectedCountry(value)}
            autoFocus={true}
            defaultMenuIsOpen={false}
            placeholder={trans.inputPlaceholder}
            showCheckmark
          />
        ) : (
          <CountrySelect
            externalList={apiCountries}
            value={country}
            onChange={(value) => setSelectedCountry(value)}
            autoFocus={false}
            defaultMenuIsOpen={false}
            placeholder={trans.inputPlaceholder}
            showCheckmark
          />
        )}
      </div>

      {!!country && !!countryDocTypes && (
        <div className="generic__document-type-wrap">
          <h2 className="generic__document-type-label" data-testid="chooseDocument">
            {trans.chooseDocument}
          </h2>
          {countryDocTypes.map((type) => {
            return isMobile ? (
              <div
                className={cx(
                  'generic__document-picker',
                  '' + type.id === docType ? 'generic__current' : ''
                )}
                onClick={() => changeSelectedDocumentType(type.id)}
                id={type.name}
                tabIndex={0}
                role="button"
                onKeyDown={(event) =>
                  onKeyDownHandler(event, () => changeSelectedDocumentType(type.id))
                }
              >
                <Icon key={type.id} type={getDocIcon(type.name)} size="32px" />
                <div className="generic__document-type-name">
                  <span>{getDocLabel(type.name)}</span>
                </div>
                <div className="generic__document-checked">
                  <Icon
                    type="selected-document"
                    size="32px"
                    color="var(--symbol-current, black)"
                    visible={`${type.id}` === docType}
                  />
                </div>
              </div>
            ) : (
              <div
                className={cx(
                  'generic__document-picker',
                  '' + type.id === docType ? 'generic__current' : ''
                )}
                onClick={() => changeSelectedDocumentType(type.id)}
                id={type.name}
                tabIndex={0}
                role="button"
                onKeyDown={(event) =>
                  onKeyDownHandler(event, () => changeSelectedDocumentType(type.id))
                }
              >
                <Icon key={type.id} type={getDocIcon(type.name)} size="32px" />
                <div className="generic__document-type-name">
                  <span>{getDocLabel(type.name)}</span>
                </div>
                <div className="generic__document-checked">
                  <Icon
                    type="selected-document"
                    size="32px"
                    color="var(--symbol-current, black)"
                    visible={`${type.id}` === docType}
                  />
                </div>
              </div>
            )
          })}
        </div>
      )}

      <div className="layout__content-container-bottom-fixed">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
        <Button
          onClick={() => handleProceed()}
          disabled={!(docType && docType.length)}
          className="button--w164"
          id="page-submit"
        >
          {btnLoading && <LoadingSpinner inButton />}
          <span
            className={cx('generic__button-text', btnLoading && 'generic__button-text--loading')}
          >
            {trans.proceed}
          </span>
        </Button>
      </div>
    </div>
  )
})
